import React, { useState } from 'react';

import styled from '@emotion/styled';

import DeleteIcon from '../../../../components/Icons/DeleteIcon';
import EditIcon from '../../../../components/Icons/EditIcon';
import { createPriceManagementActions } from '../../../../redux/slices/priceManagementSlice';
import { useAppDisPatch, useAppSelector } from '../../../../redux/store';

interface EditBundleFormButtonProps {
  pricingBundleItem: {
    id: string;
    numberOfLookups: string;
    originalPrice: string;
    newPrice: string;
    discount: string;
  };
  onToggle: () => void;
}

const DeleteBundleFormIconButton: React.FC<EditBundleFormButtonProps> = ({
  pricingBundleItem,
  onToggle,
}) => {
  const dispatch = useAppDisPatch();
  const [showDeleteMode, setShowDeleteMode] = useState(true);
  const { pricingBundle } = useAppSelector(
    (state) => state.priceManagementData,
  );
  const pricingBundleSize = pricingBundle.length;

  const handleRemovingBundle = (bundleId: string) => {
    if (pricingBundleSize > 1) {
      dispatch(createPriceManagementActions.deletePricingBundlesAtId(bundleId));
      setShowDeleteMode(false);
    }
  };

  return showDeleteMode ? (
    <IconWrapper
      onClick={() => {
        handleRemovingBundle(pricingBundleItem.id);
      }}
    >
      <DeleteIcon />
    </IconWrapper>
  ) : (
    <IconWrapper
      onClick={() => {
        onToggle();
        setShowDeleteMode(true);
      }}
    >
      <EditIcon />
    </IconWrapper>
  );
};

export default DeleteBundleFormIconButton;

const IconWrapper = styled.div`
  cursor: pointer;
`;
